'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // Aka. "Lähtölista"

// Displays a list of search results, which may be departures or day capacity
// items.
// Takes search criteria from outside, e.g. from a winresDeparturesSearch
// component.

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import {} from '../../../core/searchFilter';

var WinresDestinationsFilterController = function () {
    function WinresDestinationsFilterController($document, $scope, $timeout, $filter, $window, $q, departureService, localizationService, productService, regionService, discountService, paramService, internetClassificationService, urlService, ownerService) {
        _classCallCheck(this, WinresDestinationsFilterController);

        this.$document = $document;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$window = $window;
        this.$q = $q;

        this.departureService = departureService;
        this.localizationService = localizationService;
        this.searchCriteria = null;
        this.hasMore = false;
        this.loading = 0;
        this.data = [];
        this.noResults = false;
        this.spaceLeftText = "";
        this.results = null;
        this.productService = productService;
        this.$scope.langCode = this.localizationService.getLanguage();
        this.hideFilterSidebar = null;
        this.hideFilters = null;
        this.resultsTitleText = null;
        this.loadMap = false;
        this.showOnlyReservable = false;
        this.regionService = regionService;
        this.discountService = discountService;
        this.paramService = paramService;
        this.internetClassificationService = internetClassificationService;
        this.urlService = urlService;
        this.ownerService = ownerService;

        this.needCombination = this.needCombineResults === 'true' ? true : false;
    }

    _createClass(WinresDestinationsFilterController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().SelectedDeparture
            // getSeoState()


            this.data = this.winresReservationContext.getContext();

            //console.log("data", this.data);

            this.useSeoLinks = this.winresReservationContext.getSeoState();

            // Get Winres params
            // Hide results while loading
            this.getWinresParams();

            this.sortOptionsAvailable = [];

            this.getSortOptions();

            this.hasGoogle = 'google' in window && (typeof google === 'undefined' ? 'undefined' : _typeof(google)) === 'object' && _typeof(google.maps) === 'object';

            this.getCriteriaDefs();

            this.sort = this.sortOptionsAvailable[0];

            this.$scope.$watch('$ctrl.sort', function () {
                return _this.sortChanged();
            });

            this.$scope.visibleFilters = this.getVisibleFilters();

            this.$scope.slider = {
                min: 1,
                max: 3,
                options: {
                    ceil: 30,
                    floor: 1
                }
            };

            this.$scope.getStars = function () {
                // FOR TESTING
                // TODO: Replace with something that actually gives the stars for every single result
                return 3;
            };

            // Options for date picker
            this.$scope.datepicker_options_start = {
                showWeeks: false,
                minDate: new Date(),
                startingDay: 1,
                maxMode: 'day',
                minMode: 'day'
            };
            this.$scope.datepicker_options_end = _.clone(this.$scope.datepicker_options_start);

            // All filters are stored in this object
            this.$scope.activeFilters = {
                searchFieldTerm: '',
                searchTerms: [],
                numOfBeds: 2,
                duration: {
                    startDate: null,
                    endDate: null
                },
                priceRange: {
                    min: null,
                    max: null
                },
                starRatings: {
                    one: false,
                    two: false,
                    three: false,
                    four: false,
                    five: false
                },
                searchCriteriaDefinitions: {
                    // These vary from database to database
                    // So they are fethced in onInit with this.productService.getCriteriaDefs()
                },
                regions: []
            };

            this.$scope.onClearFilters = function () {
                _this.$scope.activeFilters = {
                    searchFieldTerm: '',
                    searchTerms: [],
                    numOfBeds: 2,
                    duration: {
                        startDate: null,
                        endDate: null
                    },
                    priceRange: {
                        min: null,
                        max: null
                    },
                    starRatings: {
                        one: false,
                        two: false,
                        three: false,
                        four: false,
                        five: false
                    },
                    searchCriteriaDefinitions: _.cloneDeep(_this.$scope.criteriaDefs),
                    regions: _.cloneDeep(_this.$scope.regionDefs)
                };
                _this.resetCriteriaSliders();
                _this.updateCriteriaSliders();
            };

            // Update active region filters.
            this.updateActiveRegionFilters();

            // Watch and filter results by active filters.
            this.watchActiveFilters();

            this.$scope.onDurationChange = function () {
                if (!_this.$scope.activeFilters.duration.startDate || !_this.$scope.activeFilters.duration.endDate) {
                    return;
                }
                // console.log('startDate: ');
                // console.log(this.$scope.activeFilters.duration.startDate);
                // console.log('endDate: ');
                // console.log(this.$scope.activeFilters.duration.endDate);
                var searchCriteria = _.cloneDeep(_this.searchCriteria);
                searchCriteria.StartDate = moment(_this.$scope.activeFilters.duration.startDate).format('YYYY-MM-DD');
                searchCriteria.EndDate = moment(_this.$scope.activeFilters.duration.endDate).format('YYYY-MM-DD');
                console.log("[WinresDeparturesList] Received search criteria:", searchCriteria);
                if (searchCriteria != null) {
                    _this.loadInitial(searchCriteria);
                }
            };

            this.$scope.onSearchTermSubmit = function () {
                if (_this.$scope.activeFilters.searchFieldTerm && _this.$scope.activeFilters.searchFieldTerm !== '') {
                    var activeFiltersCopy = _this.$scope.activeFilters;
                    activeFiltersCopy.searchTerms.push(_this.$scope.activeFilters.searchFieldTerm);
                    activeFiltersCopy.searchFieldTerm = '';
                    _this.$scope.activeFilters = activeFiltersCopy;
                }
            };

            this.$scope.removeSearchTerm = function (index) {
                if (_this.$scope.activeFilters.searchTerms.length > index) {
                    if (_this.$scope.activeFilters.searchTerms[index] == _this.$scope.searchFieldTerm) _this.$scope.searchFieldTerm = '';
                    var activeFiltersCopy = _this.$scope.activeFilters;
                    activeFiltersCopy.searchTerms.splice(index, 1);
                    _this.$scope.activeFilters = activeFiltersCopy;
                }
            };

            this.$scope.getRoundedPrice = function (price) {
                if (price >= 1000) {
                    price = _.round(price);
                } else {
                    // Round price to 2 decimal places
                    price = _.round(price * 100) / 100;
                }

                var decimalPlaces = _.isInteger(price) ? 0 : 2;
                return _this.$filter('currency')(price, '€', decimalPlaces);
            };

            // Show destinations from same area
            // Set watch for destination and trigger search

            if (this.showSameAreaDestinations) {
                this.$scope.$watch(function () {
                    return _this.data.Destination;
                }, function (destination) {
                    if (_this.loading) return;
                    console.log("[WDF showSameAreaDestinations] Watch fired! the 'destination' is: ", destination);
                    if (destination != null) {
                        _this.reload();
                    }
                });
            }

            if (this.showMapDestinations === 'true') {
                this.showMapDestinations = true;
                this.loadMap = true;
            } else this.showMapDestinations = false;

            // Title above destinations.
            if (this.titleAccommodation || this.titleActivity) {
                this.$scope.$watch(function () {
                    return _this.data.Destination;
                }, function (destination) {
                    if (destination.Type === 'OP' && _this.titleActivity) _this.title = _this.titleActivity;else if (_this.titleAccommodation) _this.title = _this.titleAccommodation;
                });
            }

            this.showOnlyReservable = this.showOnlyReservableProducts === 'true' ? true : false;

            if (window.innerWidth <= 767) {
                this.hideFilters = true;
            }
        }
    }, {
        key: 'watchActiveFilters',
        value: function watchActiveFilters() {
            var _this2 = this;

            this.$scope.$watch('activeFilters', function () {
                return _this2.updateFilteredResults();
            }, true);
            this.$scope.$watch('$ctrl.showOnlyReservable', function () {
                return _this2.updateFilteredResults();
            });
        }
    }, {
        key: 'updateFilteredResults',
        value: function updateFilteredResults() {
            var _this3 = this;

            var filteredCombinedResults = this.$filter('combinedFilter')(this.results, this.$scope.activeFilters);

            // Additional filtering for reservable products.
            this.filteredResults = _.filter(filteredCombinedResults, function (filteredResult) {
                return _this3.showOnlyReservable && filteredResult.Product.IsReservableWithCurrentCriteria || !_this3.showOnlyReservable;
            });
            if (!this.urlService.isKohdeSivu()) {
                // Must not be kohdesivu.
                // Removable filter buttons.
                this.createRemoveableCriteriaFilters();
            }
        }
    }, {
        key: 'createRemoveableCriteriaFilters',
        value: function createRemoveableCriteriaFilters() {
            var _this4 = this;

            var language = this.localizationService.getLanguage();

            this.urlService.watchUrlParams(function (params) {
                // Show removeable filter buttons only if url params are set.
                if (params !== undefined) {
                    var promises = [
                    // Get internet classification names.
                    // TODO: Use better way to get them.
                    _this4.internetClassificationService.loadInternetClassifications(), _this4.ownerService.getOwnerCompanyNames(params.dp || '')];

                    _this4.$q.all(promises).then(function (_ref) {
                        var _ref2 = _slicedToArray(_ref, 2),
                            intClasses = _ref2[0],
                            companyNames = _ref2[1];

                        // Classifications (dc[n]) in url params and winresDeparturesSearch default classifications.
                        var classificationsInUse = _this4.urlService.getClassifcationsInUse(params);

                        // Flat GetInternetClassifications result.
                        // Used to name classifications.
                        var typesFlat = getTypesFlat(intClasses);

                        var removeableClassifications = [];
                        _.each(classificationsInUse, function (classes) {
                            removeableClassifications = _.concat(removeableClassifications, _.map(classes, function (c) {
                                return {
                                    // TODO: Use better way to get localized names.
                                    'name': _.find(typesFlat, function (f) {
                                        return f.Code === c.code;
                                    })['Name' + _.capitalize(language)],
                                    'type': 'classification',
                                    'forced': c.forced,
                                    'onclick': function onclick() {
                                        return c.forced ? undefined // Disabled.
                                        : _this4.urlService.removeUrlParam('dc' + c.level, c.code);
                                    }
                                };
                            }));
                        });

                        var removeableCompanyNames = _.map(companyNames, function (company) {
                            return {
                                'name': company.CompanyName,
                                'type': 'companyName',
                                'onclick': function onclick() {
                                    return _this4.urlService.removeUrlParam('dp', company.Owner);
                                }
                            };
                        });

                        // Visible removeable filter buttons.
                        // Classifications + company names.
                        _this4.$scope.removeableCriteriaFilters = _.concat(removeableClassifications, removeableCompanyNames);
                    });
                }
            });
        }
    }, {
        key: 'getCriteriaDefs',
        value: function getCriteriaDefs() {
            var _this5 = this;

            var flags = ['onlyAsFilter', 'filterAndDisplay'];

            // accommodation, activity or package
            // If undefined, return all criteria filter product types.
            flags.push(this.criteriaFilterProductType || 'ignoreProductType');

            this.productService.getCriteriaDefs(flags).then(function (result) {
                _this5.$scope.criteriaDefs = _.cloneDeep(result);
                _this5.$scope.activeFilters.searchCriteriaDefinitions = _.cloneDeep(result);

                _this5.defineCriteriaSliders(result);
                // console.log("[winresDestinationFilter] searchCriteriaDefinitions" , this.$scope.activeFilters.searchCriteriaDefinitions);
            }).catch(function (error) {
                console.error("[winresDestinationFilter] Failed to load search criteria definitions: ", error);
            });
        }
    }, {
        key: 'getWinresParams',
        value: function getWinresParams() {
            var _this6 = this;

            this.canShowResults = false;

            this.paramService.getWinresParam('CanShowProductName').then(function (param) {
                _this6.showProductName = param.toUpperCase() === 'TRUE';
                _this6.canShowResults = true;
            });
        }
    }, {
        key: 'showMap',
        value: function showMap() {
            this.showMapDestinations = true;
            this.loadMap = true;
        }
    }, {
        key: 'hideMap',
        value: function hideMap() {
            this.showMapDestinations = false;
            this.loadMap = true;
        }
    }, {
        key: 'toggleMap',
        value: function toggleMap() {
            if (this.showMapDestinations === "true") this.showMapDestinations = true;
            if (this.showMapDestinations === "false") this.showMapDestinations = false;

            this.showMapDestinations = !this.showMapDestinations;
            this.loadMap = true;
        }
    }, {
        key: 'updateActiveRegionFilters',
        value: function updateActiveRegionFilters() {
            var _this7 = this;

            var language = this.localizationService.getLanguage();

            this.regionService.getRegions(language).then(function (regions) {
                // Default regions.
                _this7.$scope.regionDefs = _.map(regions, function (region) {
                    return {
                        code: region.Code,
                        name: region.Name,
                        value: false // Not checked by default.
                        // value: true // Checked by default.
                    };
                });

                _this7.$scope.activeFilters.regions = _.cloneDeep(_this7.$scope.regionDefs);
            });
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(changes) {
            // if(this.searchByDestination)
            //     return;

            //console.log(changes);
            if (!changes.hasOwnProperty('searchCriteria')) {
                return;
            }
            var searchCriteria = changes.searchCriteria.currentValue;
            //console.log("[WinresDeparturesList] Received search criteria:", searchCriteria);
            if (searchCriteria != null) {
                this.loadInitial(searchCriteria);
            }
        }

        // this is to get the i18next names for sort options

    }, {
        key: 'getTanslatedNames',
        value: function getTanslatedNames() {
            // check if the names have already been translated
            //console.log("this.sortOptionsAvailable", this.sortOptionsAvailable);
            if (this.sortOptionsAvailable[0].name.includes('sort.')) {
                // check if this.$filter have been loaded.
                if (this.$filter('i18next')('common.yes') != '') {
                    for (var i = 0; i < this.sortOptionsAvailable.length; i++) {
                        this.sortOptionsAvailable[i].name = this.$filter('i18next')(this.sortOptionsAvailable[i].name);
                    }
                    return this.sortOptionsAvailable;
                }
            } else {
                return this.sortOptionsAvailable;
            }
        }
    }, {
        key: 'generateSortSeed',
        value: function generateSortSeed() {
            this.sortSeed = Math.floor(Math.random() * 16384);
        }
    }, {
        key: 'resetSortFlags',
        value: function resetSortFlags() {
            this.sortFlags = this.defaultSortFlags ? _.cloneDeep(this.defaultSortFlags) : [];
        }
    }, {
        key: 'filterSortFlags',
        value: function filterSortFlags(flags) {
            var filterFlags = [];
            _.each(this.sortFlags, function (sortFlag) {
                var flag = sortFlag.indexOf(':') > -1 ? sortFlag.split(':')[0] : sortFlag;
                if (flags.search(new RegExp(flag, 'i')) == -1) filterFlags.push(sortFlag);
            });
            this.sortFlags = filterFlags;
        }
    }, {
        key: 'addSortFlag',
        value: function addSortFlag(flag) {
            this.resetSortFlags();
            this.filterSortFlags('price,random');

            if (flag.search(/random/i) > -1) {
                flag = 'Random: ' + this.sortSeed;
            }
            this.sortFlags.push(flag);
        }
    }, {
        key: 'getSortFlags',
        value: function getSortFlags() {
            this.generateSortSeed();

            if (this.sortFlags) {
                if (!Array.isArray(this.sortFlags)) {
                    this.sortFlags = this.sortFlags.split(',');
                }
            } else {
                this.sortFlags = [];
            }

            var key = void 0;
            for (key in this.sortFlags) {
                if (this.sortFlags[key].search(/random/i) > -1) {
                    this.sortFlags[key] = 'Random: ' + this.sortSeed;
                }
            }

            if (!this.defaultSortFlags) {
                this.defaultSortFlags = _.cloneDeep(this.sortFlags);
            }
        }
    }, {
        key: 'getSortOptions',
        value: function getSortOptions() {
            var _this8 = this;

            this.getSortFlags();

            if (this.sortOptions) {
                this.sortOptions = this.sortOptions.split(",");
                _.each(this.sortOptions, function (option) {
                    var id = option.trim();
                    var name = "sort." + _.trim(option);
                    _this8.sortOptionsAvailable.push({ 'id': id, 'name': name });
                });
                console.log("sortOptions: ", this.sortOptionsAvailable);
            } else {
                console.error("sort-options are required, see winresDestionationsFilter.js file");
            }
        }
    }, {
        key: 'sortChanged',
        value: function sortChanged() {
            switch (this.sort.id) {
                case "priceLH":
                    this.addSortFlag('Price');
                    break;
                case "priceHL":
                    this.addSortFlag('!Price');
                    break;
                case "random":
                    this.addSortFlag('Random');
                    break;
                default:
                    this.resetSortFlags();
            }

            // Update
            if (this.searchCriteria) {
                this.reload();
            }
        }
    }, {
        key: 'loadInitial',
        value: function loadInitial(searchCriteria) {
            var _this9 = this;

            // Clear filters on new search.
            this.$scope.onClearFilters();

            // Initial values
            this.results = [];
            this.noResults = false;

            var thisLoadInitial = Symbol();
            this.mostRecentLoadInitial = thisLoadInitial;

            this.searchCriteria = _.cloneDeep(searchCriteria);
            this.load(this.searchCriteria).then(function (results) {
                if (results == null) {
                    // This is normal if the request was canceled.
                    return;
                    // console.error("[winresDestinationFilter] Error: Cloud returned null");
                } else if (thisLoadInitial !== _this9.mostRecentLoadInitial) {
                    console.log('[winres-destination-filter]', 'Got results for an outdated request. Ignoring.');
                    return;
                }
                console.log('[winres-destination-filter]', 'Got', results && results.length, 'search results.');
                _this9.results = results;
                _this9.defaultSort = results;
                //this is to handle error about not having any departures
                if (_this9.results.length == 0 || _this9.results == null) {
                    _this9.noResults = true;
                } else {
                    _this9.noResults = false;
                }

                // Reset all criteria sliders for new search.
                _this9.resetCriteriaSliders();

                // Update criteria sliders.
                _this9.updateCriteriaSliders();

                // Update visible, filtered results.
                _this9.updateFilteredResults();
            }).catch(function (error) {
                console.error("[winresDestinationFilter] Failed to load search results. Error from promise: ", error);
            });
        }
    }, {
        key: 'reload',
        value: function reload() {
            this.loadInitial(this.searchCriteria);
        }
    }, {
        key: 'loadMore',
        value: function loadMore() {
            var _this10 = this;

            if (this.loading) return;
            this.searchCriteria.Offset = this.results.length;
            this.load(this.searchCriteria).then(function (results) {
                if (results === null) {
                    // The request was canceled.
                    return;
                }
                _this10.results = _this10.results.concat(results);
                _this10.defaultSort = _this10.defaultSort.concat(results);

                _this10.updateCriteriaSliders();

                // Update visible, filtered results.
                _this10.updateFilteredResults();
                //console.log(this.results);
            });
        }

        // Gets total payment sum, including payment fee (credit card fee)

    }, {
        key: 'getTotal',
        value: function getTotal() {
            return this.results ? this.results[0].Price + "€" : null;
        }
    }, {
        key: 'getReservableProducts',
        value: function getReservableProducts(params) {
            var language = this.localizationService.getLanguage();
            params.MinCapacity = 1;
            return this.productService.getReservableProducts(params, language);
        }
    }, {
        key: 'load',
        value: function load(searchCriteria) {
            var _this11 = this;

            // Update active filters num of beds to show correct results
            this.$scope.activeFilters.numOfBeds = searchCriteria.NumAdults + searchCriteria.NumChildren;

            var filteredByIntClas = this.removeFiltersByIntClas != "" && searchCriteria.Classifications1[0] === this.removeFiltersByIntClas;

            this.filterVisibleFiltersByIntClas(filteredByIntClas);

            var language = this.localizationService.getLanguage();
            console.log("[WDF] Language is: ", language);
            var reserveLink = true;
            if (this.withReserveLink === "false") {
                reserveLink = false;
            }

            if (this.ignoreCapacity != null && this.ignoreCapacity === 'true') {
                searchCriteria.IgnoreCapacity = true;
            }

            if (this.ignoreMissingPrices != null && this.ignoreMissingPrices === 'true') {
                searchCriteria.IgnoreMissingPrice = true;
            }

            // Filter results by regions.
            if (!searchCriteria.Regions || searchCriteria.Regions.length === 0) searchCriteria.Regions = this.regions ? this.regions.split(',') : [];

            // Filter results by price categories.
            if (!searchCriteria.PriceCategories || searchCriteria.PriceCategories.length === 0) searchCriteria.PriceCategories = this.priceCategories ? this.priceCategories.split(",") : [];

            // Filter results by sort flags.
            searchCriteria.Sort = this.sortFlags || [];

            // Override current internet classifications with binding internetClassifications[n].
            this.overrideInternetClassifications(searchCriteria);

            var search = null;

            // Tämän väliaikaisratkaisun saa poistaa, kun keskusvaraamo.matkaverkko.fi:hin on
            // saatu päälle package-search=true.
            var temporaryPackageSearchDetected = searchCriteria.Classifications1 && searchCriteria.Classifications1[0] === 'PA';

            if (this.packageSearch === 'true' || temporaryPackageSearchDetected) {
                search = this.departureService.searchReservableItemsWithSearchPackages(searchCriteria,
                /*withReserveLink=*/reserveLink, language);
            } else if (this.fastCabinSearch === 'true') {
                search = this.departureService.searchReservableItemsWithSearchDayCapacity(searchCriteria,
                /*withReserveLink=*/reserveLink, language);
            } else {
                search = this.departureService.searchReservableItems(searchCriteria,
                /*withReserveLink=*/reserveLink, language);
            }

            this.loadingPromise = search;

            this.loading++;

            if (this.showSameAreaDestinations) {

                if (!this.data.Destination) {} else if (this.data.Destination) {
                    searchCriteria.Regions = [this.data.Destination.SubGroup];
                    // clear the "AK" from searhcriteria. "AK" seems to come from area services search. At least it did at the time of doing this
                    searchCriteria.Classifications1 = [];
                    console.log("Getting same area destinations... searchCriteria is: ", searchCriteria);
                }
            }

            this.loadError = null;

            return search.then(function (response) {
                _this11.loading--;

                if (response === null) {
                    console.log('[winres-destinations-filter]', 'The request was canceled.');
                    return null;
                }

                var results = response.Results;
                _.each(results, function (result) {
                    return _this11.modifyResult(result);
                });
                _this11.hasMore = response.HasMore;

                // Save discount code to session
                _this11.handleDiscountCodeSession(searchCriteria, response.Results);

                return results;
            }, function (error) {
                _this11.loading--;

                _this11.loadError = error;
                throw error;
            });
        }
    }, {
        key: 'overrideInternetClassifications',
        value: function overrideInternetClassifications(searchCriteria) {
            var i = 0;
            for (i = 0; i < 5; i++) {
                var intClas = this['internetClassifications' + i];
                if (intClas !== undefined) {
                    searchCriteria['Classifications' + i] = intClas.split(',');
                }
            }
        }
    }, {
        key: 'handleDiscountCodeSession',
        value: function handleDiscountCodeSession(searchCriteria, results) {
            // Save discount code to localStorage if
            // Discount code is set
            // Found at least 1 result
            if (searchCriteria.DiscountCode && results.length > 0) {
                this.discountService.saveDiscountCodeToLocalStorage(searchCriteria.DiscountCode);
            } else {
                this.discountService.removeDiscountCodeFromLocalStorage();
            }
        }
    }, {
        key: 'modifyResult',
        value: function modifyResult(result) {
            try {
                if (result.EndDate && new Date(result.EndDate).getFullYear() > 1900 && (!result.Product || !result.Product.ForceReservedDays)) {
                    result.DateRange = (0, _utils.formatDateRange)(result.StartDate, result.EndDate);
                } else if (result.StartDate) {
                    result.DateRange = (0, _utils.formatFinnishDatePretty)(result.StartDate);
                } else {
                    result.DateRange = '';
                }

                // console.log('[WRT] Fetching prices:', params.DestinationCode, params.ProductCode,
                //             params.StartDate, params.EndDate);
            } catch (e) {
                //console.log("ERROR!");
                console.error(e);
            }

            // HARDCODE
            this.descriptionSource = 'headline';

            var description;
            switch (this.descriptionSource) {
                case 'headline':
                    description = result.Destination.Headline;
                    break;
                case 'description':
                default:
                    description = result.Destination.DescriptionOfDestination;
            }

            // Replace null/undefined with empty string to avoid null crash later
            // in case description is missing.
            description = description || '';

            // Remove placeholder for imagegallery (with a case-insensitive regex)
            description = description.replace(/\[kuvat\]/i, '');

            //Shorten the text
            var numChars = 400;
            if (this.descriptionLength) {
                numChars = parseInt(this.descriptionLength) || 400;
            }

            if (numChars && description.length > numChars) {
                description = description.substr(0, numChars + 1).replace(/( | *[^ ]+)$/, '') + '...';
            }

            result.Description = description;
            //result.ReservationLink = getReservationLink(this, result);

            // Made for package kohdesivu
            // Replace backend link kohde or destination with reservation-link-temmplate
            // with-reserve-link must be true to make this functional
            if (this.replaceLinkTemplate === 'true' && this.withReserveLink === 'true') {
                result.ReservationLink = result.ReservationLink.replace(/\/kohde\/|\/destination\//g, '/' + this.reservationLinkTemplate + '/');
            }

            // Replace parts of backend link.
            // Syntax: replacethis;replacewith
            // MADE FOR TESTING PURPOSES ONLY. DO NOT USE IN PRODUCTION.
            if (this.forceLink) {
                var _forceLink$split = this.forceLink.split(';'),
                    _forceLink$split2 = _slicedToArray(_forceLink$split, 2),
                    a = _forceLink$split2[0],
                    b = _forceLink$split2[1];

                result.ReservationLink = result.ReservationLink.replace(a, b);
            }

            if (this.withReserveLink !== 'true') {
                var WPML = document.querySelector("meta[name=generator][content^='WPML']") && Array.from(document.querySelectorAll("link[rel=alternate]")).some(_utils2.langParameterExist);

                result.ReservationLink = (0, _utils2.getReservationLinkWithWPMLAndSeo)(this.reservationLinkTemplate, result.Destination.DestinationName, result.Destination.DestinationCode, result.StartDate.split('T')[0], result.EndDate.split('T')[0], this.localizationService.getLanguage(), this.searchCriteria.NumAdults, this.searchCriteria.NumChildren, this.searchCriteria.NumInfants, false, // No dates
                this.winresReservationContext.getSeoState(), // seo
                WPML, // wpml
                false); // departure
            }
        }
    }, {
        key: 'defineCriteriaSliders',
        value: function defineCriteriaSliders(defs) {
            // key = variable name
            // min = minimum range
            // max = maximum range
            // vmin = inner minimum range
            // vmax = inner maximum range
            var criteriaSlider = {};
            _.each(defs, function (value, key) {
                if (value.Type === "Number") {
                    criteriaSlider[key] = {
                        key: key,
                        min: 100000,
                        max: 0,
                        vmin: 0,
                        vmax: 0
                    };
                }
            });

            this.defaultCriteriaSlider = criteriaSlider;
        }
    }, {
        key: 'updateCriteriaSliders',
        value: function updateCriteriaSliders() {
            this.updateSliderRange();
            this.updateSliders();
        }
    }, {
        key: 'resetCriteriaSliders',
        value: function resetCriteriaSliders() {
            var _this12 = this;

            this.criteriaSliderRange = {};

            _.each(this.criteriaSlider, function (_, key) {
                if (_this12.criteriaSlider[key].watch) {
                    // Cancel watch.
                    _this12.criteriaSlider[key].watch();
                }
            });

            // Use default criteria sliders.
            this.criteriaSlider = _.cloneDeep(this.defaultCriteriaSlider);
        }
    }, {
        key: 'updateSliderRange',
        value: function updateSliderRange() {
            var _this13 = this;

            var mins = {};
            var maxs = {};

            _.each(this.criteriaSlider, function (_, key) {
                mins[key] = Infinity;
                maxs[key] = 0;
            });

            _.each(this.results, function (result) {
                _.each(mins, function (_, key) {
                    if (result.CriteriaValues[key] != undefined) {
                        var value = Math.floor(result.CriteriaValues[key].Value);

                        // Pick lowest possible value.
                        if (value < mins[key]) {
                            mins[key] = value;
                        }
                    }
                });

                _.each(maxs, function (_, key) {
                    if (result.CriteriaValues[key] != undefined) {
                        var value = Math.ceil(result.CriteriaValues[key].Value);

                        // Pick highest possible value.
                        if (value > maxs[key]) {
                            maxs[key] = value;
                        }
                    }
                });
            });

            // Set min and max range.
            _.each(this.criteriaSlider, function (_, key) {
                _this13.criteriaSlider[key].min = mins[key];
                _this13.criteriaSlider[key].max = maxs[key];
            });
        }
    }, {
        key: 'updateSliders',
        value: function updateSliders() {
            var _this14 = this;

            if (!this.criteriaSliderRange) {
                // This is used to keep changed slider values intact on search more.
                this.criteriaSliderRange = {};
            }

            _.each(this.criteriaSlider, function (_, key) {
                if (!_this14.criteriaSliderRange[key]) {
                    _this14.criteriaSliderRange[key] = { key: key };
                }

                if (_this14.criteriaSlider[key].max > _this14.criteriaSlider[key].min) {
                    _this14.criteriaSlider[key].show = true;
                } else {
                    // Faulty slider, hide.
                    _this14.criteriaSlider[key].show = false;
                    return;
                }

                // Reset untouched sliders.
                if (!_this14.criteriaSlider[key].touched) {
                    // Prevent marking this slider as touched.
                    _this14.criteriaSlider[key].reset = true;

                    // Reset min and max values.
                    _this14.criteriaSliderRange[key].vmin = _this14.criteriaSlider[key].min;
                    _this14.criteriaSliderRange[key].vmax = _this14.criteriaSlider[key].max;
                }

                if (_this14.criteriaSlider[key].watch === undefined) {
                    // Watch changes in criteria sliders.
                    _this14.criteriaSlider[key].watch = _this14.$scope.$watch('$ctrl.criteriaSliderRange.' + key, function (slider) {
                        if (_this14.sliderTimeout) {
                            // Cancel previous slider timeout.
                            _this14.$timeout.cancel(_this14.sliderTimeout);
                        }

                        // Trigger filtering after 0.5s.
                        _this14.sliderTimeout = _this14.$timeout(function () {
                            // Slider range changed.
                            // Set active filters searchCriteriaDefinitions.C[XX].filterVar to {min: min, max: max}
                            var min = slider.vmin;
                            var max = slider.vmax;
                            var filterVal = { min: min,
                                max: max };

                            if (filterVal.min === _this14.criteriaSlider[slider.key].min && filterVal.max === _this14.criteriaSlider[slider.key].max) {
                                // Show all results with defaults.
                                delete _this14.$scope.activeFilters.searchCriteriaDefinitions[slider.key].filterVal;
                            } else {
                                // Trigger filtering.
                                _this14.$scope.activeFilters.searchCriteriaDefinitions[slider.key].filterVal = filterVal;
                            }
                        }, 500);

                        if (_this14.criteriaSlider[slider.key].reset) {
                            // Was reseted. Do not mark this slider as touched.
                            _this14.criteriaSlider[slider.key].reset = false;
                        } else {
                            _this14.criteriaSlider[slider.key].touched = true;
                        }
                    }, true);
                }
            });
        }
    }, {
        key: 'getNoResultText',
        value: function getNoResultText() {
            if (this.noResultsText != null) {
                return this.$filter('i18next')(this.noResultsText);
            } else {
                return this.$filter('i18next')('winres_departures.no_departures_found');
            }
        }
    }, {
        key: 'isPriceDisplayed',
        value: function isPriceDisplayed(price) {
            if (this.hidePriceWhenNotReservable !== 'true') {
                return true;
            } else if (price == 0) {
                return false;
            }
            return true;
        }
    }, {
        key: 'getHowMuchSpaceIsLeftText',
        value: function getHowMuchSpaceIsLeftText() {
            if (this.spaceLeftText != "") {
                return this.spaceLeftText;
            } else if (this.data.SelectedDeparture != null) {
                if (this.data.SelectedDeparture.CapacityAvailable == 0) {
                    this.spaceLeftText = this.$filter('i18next')(this.capacityFullText);
                    return this.$filter('i18next')(this.capacityFullText);
                } else if (this.capacityBreakPoint >= this.data.SelectedDeparture.CapacityAvailable) {
                    this.spaceLeftText = (this.capacityNumber ? this.data.SelectedDeparture.CapacityAvailable : '') + this.$filter('i18next')(this.capacityBreakPointText);
                    return (this.capacityNumber ? this.data.SelectedDeparture.CapacityAvailable : '') + this.$filter('i18next')(this.capacityBreakPointText);
                } else {
                    this.spaceLeftText = this.$filter('i18next')(this.enoughCapacity);
                    return this.$filter('i18next')(this.enoughCapacity);
                }
            }
        }
    }, {
        key: 'hideEnterMessage',
        value: function hideEnterMessage() {
            this.showEnterMessage = false;
            if (this.searchFieldTimeout) {
                this.$timeout.cancel(this.searchFieldTimeout);
                this.searchFieldTimeout = undefined;
            }
        }
    }, {
        key: 'searchFieldChanged',
        value: function searchFieldChanged() {
            this.hideEnterMessage();
            var winres = this;
            this.searchFieldTimeout = this.$timeout(function () {
                var isMobile = detectMobile();
                if (!isMobile) return;
                winres.showEnterMessage = true;
            }, 500);
        }
    }, {
        key: 'searchButtonPressed',
        value: function searchButtonPressed() {
            this.$scope.searchFieldTerm = this.$scope.activeFilters.searchFieldTerm;
            this.hideEnterMessage();
        }
    }, {
        key: 'getVisibleFilters',
        value: function getVisibleFilters() {

            var defaultVisibleFilters = {
                search: true,
                duration: true,
                priceRange: true,
                waysToTravel: false,
                region: true,
                starRating: true,
                numOfBeds: true
            };

            // If some parameters are set manually, use them to override default values
            // parse user manual input ex: "search: false, priceRange: false to valid object.
            // (JSON.parse would require keys to be double quotes which is no handy for manual input
            if (this.filterVisibility) {
                var overriddenFilters = (0, _utils.commaseparatedKeyValuesToObj)(this.filterVisibility);
                var originalAndOverridenFilters = (0, _utils.overrideObjValues)(defaultVisibleFilters, overriddenFilters);
                return originalAndOverridenFilters;
            } else {
                return defaultVisibleFilters;
            }
        }
    }, {
        key: 'filterVisibleFiltersByIntClas',
        value: function filterVisibleFiltersByIntClas(filteredByIntClas) {
            // The old code here would turn these on when filteredByIntClas was false,
            // even if they were already set to false by this.filterVisibility!
            // That caused the filters to appear even in cases where they were explicitly turned off.
            if (filteredByIntClas) {
                this.$scope.visibleFilters.duration = false;
                this.$scope.visibleFilters.starRating = false;
                this.$scope.visibleFilters.numOfBeds = false;
            }
        }
    }, {
        key: 'hasPriceNote',
        value: function hasPriceNote(result) {
            return result.Product.PriceNote && result.Product.ReservabilityCheckResults.CapacityIsEnough && !result.Product.ReservabilityCheckResults.Price;
        }
    }, {
        key: 'getBannerText',
        value: function getBannerText(result) {
            var _this15 = this;

            if (this.bannerCriteriaCodes === undefined) {
                return undefined;
            }

            var language = this.localizationService.getLanguage();
            var criteriaCodes = (0, _utils2.clearWhiteSpace)(this.bannerCriteriaCodes).split(',');

            // Get banner text from criteria defs.
            // e.g.
            // - Aamiainen sisältyy.
            // - Loppusiivous sisältyy.
            var bannerText = _.map(criteriaCodes, function (criteriaCode) {
                var isValidCriteria = result.CriteriaValues[criteriaCode] !== undefined && result.CriteriaValues[criteriaCode].Value === true // Show only if true.
                && _this15.$scope.criteriaDefs[criteriaCode] !== undefined;

                return isValidCriteria ? _this15.$scope.criteriaDefs[criteriaCode].Name[language] + '<br>' : undefined;
            }).filter(function (text) {
                return text !== undefined;
            }).join('- ');

            if (bannerText === '') {
                return undefined;
            }

            return '- ' + bannerText;
        }
    }, {
        key: 'getImage',
        value: function getImage(result) {
            if (this.useImageCaching === 'true') {
                return 'https://images.weserv.nl/?url=' + result.Destination.Images[0] + '&w=300&h=300';
            }

            return result.Destination.Images[0];
        }
    }]);

    return WinresDestinationsFilterController;
}();

WinresDestinationsFilterController.$inject = ['$document', '$scope', '$timeout', '$filter', '$window', '$q', 'departureService', 'localizationService', 'productService', 'regionService', 'discountService', 'paramService', 'internetClassificationService', 'urlService', 'ownerService'];

// Reduce font size if element height is bigger than N
_module3.default.directive('reduceFontSizeHeight', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            var e = element[0];
            var fs = 950;

            // Reduce element height by reducing font size.
            function tryReduceHeight() {
                $timeout().then(function () {
                    if (e.clientHeight > +attr.reduceFontSizeHeight) {
                        e.style.fontSize = fs / e.clientHeight + 'px';
                        fs -= 100;

                        // Break after 3 iterations.
                        if (fs < 750) {
                            return;
                        }

                        // Check if element height is reduced, if not, reduce again.
                        tryReduceHeight();
                    }
                }, 10);
            }

            tryReduceHeight();
        }
    };
}]);

function getTypesFlat(types) {
    var typesFlat = types.reduce((0, _utils2.getFlatTree)(), []);

    // Return flat array of classifications without empty codes.
    return _.filter(typesFlat, function (type) {
        return type.Code !== '';
    });
}

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'destinationsFilter';
}

function detectMobile() {
    return window.innerWidth <= 800 && window.innerHeight <= 600;
}

getTemplate.$inject = ['$attrs', '$sce'];

String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

// Filters from here moved to own file that should be imported at the top..

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('destinationsFilter', require('./winresDestinationsFilter.html'));
}]);

_module3.default.component('winresDestinationsFilter', {
    templateUrl: getTemplate,
    controller: WinresDestinationsFilterController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        // made specially for the filter
        // sort options, currently available: default, priceLH, priceHL
        sortOptions: '@',

        // Binds search criteria. E.g. output of winresDeparturesSearch may
        // be passed here, or just some static value.
        searchCriteria: '<',
        // Number of characters to take from the start of description.
        // Default: 400
        descriptionLength: '@',
        // Open reservation link in a new tab
        // Reserve links have target="_blank".
        // Used in cases where the
        // departure list is shown on the customer's web page or somewhere other
        // than the reservation site. (e.g. links to Intres or something.)
        // Default: false
        reserveInNewWindow: '@',
        // Either 'description' (default) or 'headline'
        descriptionSource: '@',
        // In offers template, what to display before the price.
        // "Offer 99 €" or "Your text here 99 €"
        offerPriceText: '@',
        // Text to display when no results are found.
        noResultsText: '@',
        // replaces the string "Meno"
        departureDateString: '@',
        // replaces the string 'winres_departures.find_out_more'
        findOutMore: '@',
        // removes accommodation specific filters when int-clas1 is the class specified here.
        removeFiltersByIntClas: '@',

        // when true: hides the price when the product is not reservable. Default: false. This doesn't work always, hasn't been implemented to every possibility, go edit template.
        hidePriceWhenNotReservable: '@',
        // If true, ignores capacity in the searches. Default: false.
        ignoreCapacity: '@',
        // If true, ignores missing prices in the searches. Default: false.
        ignoreMissingPrices: '@',
        // To change the text 'winres_departures.next_departures' on top of the page.
        nextDeparturesText: '@',
        // true (default)/ false. If false, the reservelink is created in the front end.
        withReserveLink: '@',

        // Overrides the url returned by the BE, url of the kohdesivu/matkasivu, before /#!/.
        // if this does not have 'http' in the string (https also has the 'http' part in it) it will take current url and add the value of this to the end of it
        // also accepts ../ to go one "folder" up
        reservationLinkTemplate: '@',
        // false (default)/true
        displayPriceNote: '@',
        // Unused
        showFullText: '@',

        // specify all of these if used in mode: departures
        // example:
        //  capacity-break-point="6"
        //  enough-capacity="capacity.enough_capacity"
        //  capacity-number="true"
        //  capacity-break-point-text="capacity.places_left"
        //  capacity-full-text="capacity.full"
        // this is the amount of capacity when it changes from being "space left" to "not so much space left." "not so much space left" => full goes automatically when capacity == 0
        capacityBreakPoint: '@',
        // text for "space left"
        enoughCapacity: '@',
        // if "not so much space" shows exact amount left. true/false.
        capacityNumber: '@',
        // this is the text for "not so much space left"
        capacityBreakPointText: '@',
        // text for when departure is full
        capacityFullText: '@',
        // Hide filters sidebar. true or empty
        hideFilterSidebar: '@',
        // The title for search results. Should be empty (use: ' ') or text string, can be i18next string ex. "joiku.filterComponent.resultsTitle"
        resultsTitleText: '@',
        // Show map destinations.
        showMapDestinations: '@',
        // Show map selection icon.
        showMapSelectionIcon: '@',
        // Hide results header.
        hideResultsHeader: '@',
        // Filter departures by region codes. Separated by comma. "region1,region2,region3"
        regions: '@',
        // Filter departures by price categories. Separated by comma. "category1,category2,category3"
        priceCategories: '@',
        // Sort flags. IsOffer, Price, Random. Random seed is generated only once.
        sortFlags: '@',
        // Show destinations from same 'area' if this is set to 'true'
        showSameAreaDestinations: '@',
        // Accommodation title.
        titleAccommodation: '@',
        // Activity title.
        titleActivity: '@',
        // VisibleFilters
        // ex: "priceRange: true, numOfBeds: false". Current filters: search, duration, priceRange, waysToTravel, region, starRating, numOfBeds
        filterVisibility: '@',
        // Use fast cabin search
        fastCabinSearch: '@',
        // Use package search
        packageSearch: '@',
        // Hide result star rating. true/false
        hideRating: '@',
        // Replace backend link kohde or destination with reservation-link-template
        // with-reserve-link must be true to make this functional
        // true/false
        replaceLinkTemplate: '@',
        // Replace parts of backend link.
        // Syntax: replacethis;replacewith
        // MADE FOR TESTING PURPOSES ONLY. DO NOT USE IN PRODUCTION.
        forceLink: '@',
        // Criteria filter product type. accommodation, activity or package.
        criteriaFilterProductType: '@',
        // Internet classifications 1. Separated by ,
        internetClassifications1: '@',
        // Internet classifications 2. Separated by ,
        internetClassifications2: '@',
        // Internet classifications 3. Separated by ,
        internetClassifications3: '@',
        // Internet classifications 4. Separated by ,
        internetClassifications4: '@',
        // Internet classifications 5. Separated by ,
        internetClassifications5: '@',
        // Show only reservable products. true/false. default: false.
        showOnlyReservableProducts: '@',
        // Criteria texts to show in banner. Split by ,. e.g. C10,C15
        bannerCriteriaCodes: '@',
        // Use images.weserv.nl to cache and resize images. true/false
        useImageCaching: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDestinationsFilter/winresDestinationsFilter.js
// module id = 294
// module chunks = 2